import { ShieldCheck, Eye, PenLine, Shield, Flame, Star, Heart, Zap, Award, Crown, Leaf, Rocket, User, BadgeCheck } from "lucide-react";

export const BADGE_ICONES = {
  shield: Shield, eye: Eye, pen: PenLine, flame: Flame, star: Star, heart: Heart,
  zap: Zap, award: Award, crown: Crown, leaf: Leaf, rocket: Rocket, user: User, badge: BadgeCheck,
};

export const BADGE_POLICES = ["Outfit", "Inter", "Poppins", "Montserrat", "JetBrains Mono", "Georgia", "Arial"];

const BUILTIN = {
  admin: { label: "Admin", color: "#60A5FA", icon: ShieldCheck },
  gestionnaire: { label: "Gestionnaire", color: "#2DD4BF", icon: PenLine },
  lecteur: { label: "Lecteur", color: "#9CA3AF", icon: Eye },
};

function hexToRgba(hex, alpha) {
  const m = /^#([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return undefined;
  const n = parseInt(m[1], 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}

export function RoleBadge({ role, badge, testid }) {
  const builtin = BUILTIN[role];
  const color = badge?.couleur || builtin?.color || "#A78BFA";
  const Icon = (badge?.icone && BADGE_ICONES[badge.icone]) || builtin?.icon || Shield;
  const style = {
    backgroundColor: hexToRgba(color, 0.14),
    borderColor: hexToRgba(color, 0.65),
    color,
    fontFamily: badge?.police ? `'${badge.police}', sans-serif` : undefined,
    textTransform: badge?.majuscules ? "uppercase" : undefined,
    fontWeight: badge?.gras ? 800 : 600,
  };
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs" style={style} data-testid={testid || `role-badge-${role}`}>
      <Icon className="h-3 w-3" /> {builtin ? builtin.label : role}
    </span>
  );
}
